import { SelectionGroupOption } from 'common/components';
import { ADPLATFORM_TRAINING_CDN_PATH } from '../../adplatform-training-constants';

export enum AdplatformTrainingReelsTabName {
  AllReels = 'all',
  SearchReels = 'search',
  CatalogReels = 'catalog',
  CardReels = 'card',
  OtherReels = 'other',
}

export const ADPLATFORM_TRAINING_REELS_TABS_LIST: SelectionGroupOption[] = [
  {
    text: 'Все рекламные места',
    value: AdplatformTrainingReelsTabName.AllReels,
  },
  {
    text: 'Поиск',
    value: AdplatformTrainingReelsTabName.SearchReels,
  },
  {
    text: 'Каталог',
    value: AdplatformTrainingReelsTabName.CatalogReels,
  },
  {
    text: 'Карточка товара',
    value: AdplatformTrainingReelsTabName.CardReels,
  },
  {
    text: 'Другое',
    value: AdplatformTrainingReelsTabName.OtherReels,
  },
];

export type AdplatformTrainingReelStructure = {
  title: string;
  image: {
    srcD: string;
    srcT: string;
    srcM: string;
    alt: string;
  };
  video?: {
    src: string;
    alt: string;
  };
  type?: AdplatformTrainingReelsTabName;
  href?: string;
};

export const ADPLATFORM_TRAINING_MEDIA_DATA: AdplatformTrainingReelStructure = {
  title: 'Медиакит рекламной платформы',
  image: {
    srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/media-d.jpg/media-d-04.jpg`,
    srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/media-t.jpg/media-t-04.jpg`,
    srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/media-m.jpg/media-m-05.jpg`,
    alt: 'Скачать медиакит рекламной платформы',
  },
  href:
    'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/Mediakit-reklamnaya-platforma.pdf',
};

export const ADPLATFORM_TRAINING_INSTRUCTION_DATA: AdplatformTrainingReelStructure = {
  title: 'Перейти в Базу знаний рекламной платформы',
  image: {
    srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/instruction-d.jpg/instruction-d-01.jpg`,
    srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/instruction-t.jpg/instruction-t-01.jpg`,
    srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/instruction-m.jpg/instruction-m-01.jpg`,
    alt: 'Как эффективно запустить онлайн-рекламу на Лемана ПРО',
  },
  href:
    'https://s5-lemanapro.teamly.ru/space/0604cf07-0124-4736-b1b7-0b2d7a151c24/article/156d8fab-8adc-4ee2-b949-3eb305d332ab',
};

export const ADPLATFORM_TRAINING_REELS_LIST: AdplatformTrainingReelStructure[] = [
  {
    title: 'Как завести первую рекламную кампанию',
    image: {
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-zavesti-pervuyu-reklamnuyu-kampaniyu-d.jpg/kak-zavesti-pervuyu-reklamnuyu-kampaniyu-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-zavesti-pervuyu-reklamnuyu-kampaniyu-t.jpg/kak-zavesti-pervuyu-reklamnuyu-kampaniyu-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-zavesti-pervuyu-reklamnuyu-kampaniyu-m.jpg/kak-zavesti-pervuyu-reklamnuyu-kampaniyu-m.jpg`,
      alt: 'Смотреть видео как завести первую рекламную кампанию',
    },
    video: {
      src:
        'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fkak-zavesti-kampaniyu.mp4/kak-zavesti-kampaniyu.mp4',
      alt: 'Как завести первую рекламную кампанию',
    },
    type: AdplatformTrainingReelsTabName.OtherReels,
  },
  {
    title: 'Поднятие товаров в\u00A0поиске',
    image: {
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-podnyat-tovary-v-poiske-d.jpg/kak-podnyat-tovary-v-poiske-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-podnyat-tovary-v-poiske-t.jpg/kak-podnyat-tovary-v-poiske-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-podnyat-tovary-v-poiske-m.jpg/kak-podnyat-tovary-v-poiske-m.jpg`,
      alt: 'Смотреть видео как поднять товары в поиске',
    },
    video: {
      src:
        'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fkak-podnyat-tovary-v-poiske.mp4/kak-podnyat-tovary-v-poiske.mp4',
      alt: 'Как поднять товары в поиске',
    },
    type: AdplatformTrainingReelsTabName.SearchReels,
  },
  {
    title: 'Поднятие товаров в\u00A0каталоге',
    image: {
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-podnyat-tovary-v-kataloge-d.jpg/kak-podnyat-tovary-v-kataloge-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-podnyat-tovary-v-kataloge-t.jpg/kak-podnyat-tovary-v-kataloge-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-podnyat-tovary-v-kataloge-m.jpg/kak-podnyat-tovary-v-kataloge-m.jpg`,
      alt: 'Смотреть видео как поднять товары в каталоге',
    },
    video: {
      src:
        'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fkak-podnyat-tovary-v-kataloge.mp4/kak-podnyat-tovary-v-kataloge.mp4',
      alt: 'Как поднять товары в каталоге',
    },
    type: AdplatformTrainingReelsTabName.CatalogReels,
  },
  {
    title: 'Как создать блок рекомендаций в\u00A0карточке товара',
    image: {
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-sozdat-blok-rekomendacij-v-kartochke-tovara-d.jpg/kak-sozdat-blok-rekomendacij-v-kartochke-tovara-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-sozdat-blok-rekomendacij-v-kartochke-tovara-t.jpg/kak-sozdat-blok-rekomendacij-v-kartochke-tovara-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-sozdat-blok-rekomendacij-v-kartochke-tovara-m.jpg/kak-sozdat-blok-rekomendacij-v-kartochke-tovara-m.jpg`,
      alt: 'Смотреть видео как создать блок рекомендаций в карточке товара',
    },
    video: {
      src:
        'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fkak-sozdat-blok-rekomendacij-v-kartochke-tovara.mp4/kak-sozdat-blok-rekomendacij-v-kartochke-tovara.mp4',
      alt: 'Как создать блок рекомендаций в карточке товара',
    },
    type: AdplatformTrainingReelsTabName.CardReels,
  },
  {
    title: 'Как настраивать групповые условия для кампаний',
    image: {
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-nastraivat-gruppovye-usloviya-dlya-kampanij-d.jpg/kak-nastraivat-gruppovye-usloviya-dlya-kampanij-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-nastraivat-gruppovye-usloviya-dlya-kampanij-t.jpg/kak-nastraivat-gruppovye-usloviya-dlya-kampanij-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/kak-nastraivat-gruppovye-usloviya-dlya-kampanij-m.jpg/kak-nastraivat-gruppovye-usloviya-dlya-kampanij-m.jpg`,
      alt: 'Смотреть видео как настраивать групповые условия для кампаний',
    },
    video: {
      src:
        'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fkak-nastraivat-gruppovye-usloviya-dlya-kampanij.mp4/kak-nastraivat-gruppovye-usloviya-dlya-kampanij.mp4',
      alt: 'Как настраивать групповые условия для кампаний',
    },
    type: AdplatformTrainingReelsTabName.OtherReels,
  },
  {
    title: 'Ошибки при поднятии товаров в поиске',
    image: {
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/oshibki-pri-podnyatii-tovara-v-kataloge-d.jpg/oshibki-pri-podnyatii-tovara-v-kataloge-d-1.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/oshibki-pri-podnyatii-tovara-v-kataloge-t.jpg/oshibki-pri-podnyatii-tovara-v-kataloge-t-1.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/reels/oshibki-pri-podnyatii-tovara-v-kataloge-m.jpg/oshibki-pri-podnyatii-tovara-v-kataloge-m-1.jpg`,
      alt: 'Смотреть видео разбора ошибок при поднятии товаров в поиске',
    },
    video: {
      src:
        'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Foshibki-pri-podnyatii-tovara-v-kataloge.mp4/oshibki-pri-podnyatii-tovara-v-kataloge.mp4',
      alt: 'Разбор ошибок при поднятии товаров в поиске',
    },
    type: AdplatformTrainingReelsTabName.SearchReels,
  },
];
